import { registerMutation } from 'data-fetching-client';
import { createOnboardingLink } from '../api/OnboardingLinkApi';
export const CREATE_ONBOARDING_LINK = registerMutation({
  fieldName: 'onBoardingLink',
  args: ['type'],
  fetcher: createOnboardingLink
});